/* eslint-disable no-console */
// TODO:: Убрать все console.log после подключения GlitchTip
import { captureException } from "@sentry/browser";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { loadReCaptcha } from "recaptcha-v3-react-function-async";
import { useVkAnalytics } from "@/helpers/useVkAnalytics.js";
import { JuicySession } from "@/helpers/juicySession";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { YandexMetrika } from "./components/YandexMetrika";
import "./css/index.css";
import { useJuicyScript } from "./helpers/useJuicyScript";
import { useServerSettings } from "./helpers/useServerSettings";
import { useUserExperiments } from "./helpers/useUserExperiments";
import { useUxFeedbackData } from "./helpers/useUxFeedbackData";
import { useYandexMetrics } from "./helpers/useYandexMetrics";
import { useLoaders } from "./hooks/useLoaders";
import { AppRouter } from "./router/AppRouter";
import { selectServerSettings } from "./store/selectors";

export const Layout = () => {
  const serverSettings = useSelector(selectServerSettings);
  const captchaSiteKey3 = serverSettings?.GoogleReCaptchaSiteKey_v3;

  useEffect(() => {
    if (!captchaSiteKey3) return;

    const loadCaptcha = async () => {
      try {
        await loadReCaptcha(captchaSiteKey3);
        console.log("Recaptcha loaded");
      } catch (e) {
        captureException(e, "Error when loaded ReCaptcha");
      }
    };

    loadCaptcha();
  }, [captchaSiteKey3]);

  // Тянем настройки с сервера
  useServerSettings();
  // Сообщаем VK метрике об изменении страниц SPA
  useVkAnalytics();
  // Сообщаем Yandex метрике об изменении страниц SPA
  useYandexMetrics();
  // Устанавливаем contactId для uxFeedback
  useUxFeedbackData();
  // Подключаем Juicy Scoring
  useJuicyScript();
  // Обновляем активные для юзера эксперименты
  useUserExperiments();
  // Загружаем лоадеры
  useLoaders();

  return (
    <JuicySession>
      <Header />
      <AppRouter />
      <Footer />
      <YandexMetrika />
    </JuicySession>
  );
};
